import { render, staticRenderFns } from "./BannerCompany.vue?vue&type=template&id=1984eadb&scoped=true&"
import script from "./BannerCompany.vue?vue&type=script&lang=ts&"
export * from "./BannerCompany.vue?vue&type=script&lang=ts&"
import style0 from "./BannerCompany.vue?vue&type=style&index=0&id=1984eadb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1984eadb",
  null
  
)

export default component.exports